import { render, staticRenderFns } from "./semaforo.vue?vue&type=template&id=29b5c208&scoped=true&"
import script from "./semaforo.vue?vue&type=script&lang=js&"
export * from "./semaforo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b5c208",
  null
  
)

export default component.exports